import { create } from "zustand";

interface PreviewExitGuardState {
  // Registered by the upload preview screen while a preview is pending. The
  // sidebar calls it to intercept a same-route exit attempt (clicking the
  // already-active "Datos" item), where react-router fires no navigation and
  // the route blocker never triggers. Null when no preview is pending, so
  // navigation behaves normally.
  onSameRouteExit: (() => void) | null;
  setOnSameRouteExit: (handler: (() => void) | null) => void;
}

export const usePreviewExitGuardStore = create<PreviewExitGuardState>()(
  (set) => ({
    onSameRouteExit: null,
    setOnSameRouteExit: (handler) => set({ onSameRouteExit: handler }),
  }),
);
